document.addEventListener("DOMContentLoaded", function() {
	"use strict";
    
    //Analog zu include-busy.js:
    //- Früher war ein #iframe-submit-busy direkt im IFrame-PageLayout jeweils vorhanden (durch XSLT eingefügt).
    //- Das war aber im Inhaltsbereich, und seit das ein CSS-Container ist, musste dieses Busy verschoben werden / außerhalb des Containers angeordnet werden.
    //- Das könnte man zwar im XSLT allein lösen, aber analog zu #iframe-submit-busy soll das Div nun einfach direkt vom Script injiziert werden (am Ende des Bodys).
    //- Falls noch irgendwo PageLayout-Templates verwendet werden sollten, die das Element noch (an der nun falschen, mit dem aktuellen CSS
    //  nicht mehr kompatiblen) Stelle enthalten, suche nach nicht aktiviertem Submit-Element und lösche das ggf., bevor das neue injiziert wird.

    //1. Ggf. altes Relikt entfernen:
    var relict = document.querySelector("#iframe-submit-busy:not(.active)");
    if (relict !== null)
        relict.remove();
    //2. Neu einfügen:
    document.body.insertAdjacentHTML('beforeend', '<div id="iframe-submit-busy" class="busy-page-overlay topmost"><div class="busy-overlay"></div></div>');

    //3. nun wie gehabt aktivieren
	var inner = document.querySelector("#iframe-submit-busy:not(.active) .busy-overlay");
	var img = document.createElement("img");
	img.setAttribute("src", "/images/waitIndicatorClockOnlyWhite.svg");
	img.setAttribute("alt", "Warteanzeige (Uhr)");
	inner.appendChild(img);
	var busy = document.querySelector("#iframe-submit-busy:not(.active)");
	busy.classList.add("active");
	busy.style.display = "none";
	busy.setAttribute("title", "Datenübertragung (Anfrage senden und Antwort empfangen)…");
	
	var closeBtn = document.createElement("button");
	closeBtn.classList.add("custom"); //Verhindert, dass das Standard-Button-CSS angewendet wird
	closeBtn.classList.add("close"); //Eigenes CSS nur für diesen Button
	busy.appendChild(closeBtn);
	var closeImg = document.createElement("img");
	closeImg.setAttribute("src", "/images/close-cross.svg");
	closeImg.setAttribute("alt", "Overlay ausblenden");
	closeBtn.appendChild(closeImg);
	
	var plane = document.getElementById("iframe-submit-busy");
	
	//Für den Fehlerfall (Request wird irgendwie nicht abgeschlossen) sollte ein Schließen des Overlays möglich sein, so dass die Seite wieder bedienbar wird.
	closeBtn.addEventListener("click", function() {
		plane.style.display="none";
		plane.classList.remove("fade");
	});
	
	var forms = document.querySelectorAll("form:not(.no-iframe-submit)");
	for (var i=0, l=forms.length; i < l; i++) {
		forms[i].addEventListener("submit", function(ev) {
			
			plane.style.display = "block";
			//Bei schnellen Requests, d.h. mit sehr kurzen Wartezeiten, wirkte ein sofortiges Abdunkeln der gesamten Frame-Fläche
			//eher unangenehm/störend, daher erstmal nur ein transparentes Overlay drüberlegen, das dann im Anschluss langsam
			//per Transition dunkler werden soll (nur falls der Request überhaupt länger dauert).
			//Transition wird per CSS geregelt durch Hinzufügen der Class "fade".
			//Die Transition funktioniert aber evtl. nicht, wenn die Class sofort mit dem Setzen der Display-Eigenschaft gesetzt wird.
			//Bewährt hat sich dagegen: Erstmal anzeigen (transparent) und erst nach einem Timeout (derzeit 0.5 s) mit dem Fadeout
			//beginnen:
			window.setTimeout(function() {
				//Falls inzwischen ein anderer, später ausgeführter Eventhandler (wie FormValidation)
				//das Submit-Event gecancelt haben sollte, blende die plane wieder aus, ansonsten sorge für den Fade-Effekt.
				if (ev.defaultPrevented)
					plane.style.display = "none";
				else
					plane.classList.add("fade");
			}, 500); //Erst nach 5 Sekunden Wartezeit einblenden.
		});
	}
    
    var links = document.querySelectorAll("a.busylink");
    for (var j=0, ll=links.length; j < ll; j++) {
        var link = links[j];
        var isDownload = link.classList.contains("download");
        links[j].addEventListener("click", function() {
            plane.style.display = "block";
			window.setTimeout(function() {
				plane.classList.add("fade");
                if (isDownload) {
                    //Da nicht festgestellt werden kann, wann der Download fertig ist und bei content-disposition:attachment auch der Seiteninhalt
                    //nicht ersetzt wird, sondern geöffnet wird, soll die Busy-Anzeige nach einiger Zeit wieder langsam ausgeblendet werden.
                    window.setTimeout(function() {
                        plane.classList.remove("fade");
                        window.setTimeout(function() {
                            plane.style.display = "none";
                        }, 3000); //Da der Fadeout derzeit 3s dauert (vgl. CSS), warte auch hier 3s ab, bis alles ganz ausgeblendet wird.
                    }, 30000); //Warte 30 Sekunden, bevor mit dem Fadeout begonnen wird.
                }
			}, 500); //Erst nach 5 Sekunden Wartezeit einblenden.
        });
    }
});